__turbopack_context__.v({
  "full_width": "revealOnScroll-module-scss-module__ulPDaa__full_width",
  "wrapper": "revealOnScroll-module-scss-module__ulPDaa__wrapper",
});
